import { clusterSourceGroups } from '../../utils/sourceGroupClustering';
import type { KnownDetailType, KnownEntityType, KnownSourceGroup } from '../../types';
import SourceGroupCluster from '../SourceGroupCluster/SourceGroupCluster';
import SourceGroupRow from '../SourceGroupRow/SourceGroupRow';

interface SourceGroupEntriesProps {
    groups: KnownSourceGroup[];
    type: KnownDetailType;
    entityType: KnownEntityType;
}

/** The single place source groups become rows — the drawer and the director cards must cluster identically. */
const SourceGroupEntries = ({ groups, type, entityType }: SourceGroupEntriesProps) => (
    <>
        {clusterSourceGroups(groups).map((entry, index) =>
            entry.kind === 'cluster' ? (
                <SourceGroupCluster
                    key={`${entry.groups[0].sourceId}-cluster-${index}`}
                    label={entry.label}
                    groups={entry.groups}
                    type={type}
                    entityType={entityType}
                />
            ) : (
                <SourceGroupRow key={`${entry.group.sourceId}-${index}`} group={entry.group} type={type} entityType={entityType} />
            ),
        )}
    </>
);

export default SourceGroupEntries;
